/**
 * Atlas field bridge (2026-06-28)
 *
 * The variable `VAR` dropdown on a block is the same target the side-panel "swap variable" button
 * acts on. That button calls `openAtlasForBlock()` when `selectedBlockFlag` is true (context set by
 * the workspace SELECTED handler). To make clicking the dropdown itself open Atlas — on EVERY block,
 * not just the few re-registered in the component — the block defs live in helper files that have no
 * reference to the component. This module-level bridge lets those helper `NonEditableFieldVariable`
 * classes trigger the EXACT swap-button action without a circular import.
 *
 * The component registers `open` in ngAfterViewInit; a field's `showEditor_` calls it. Reusing
 * `openAtlasForBlock()` (gated on `selectedBlockFlag`) means the click-to-open path and the button
 * are behaviourally identical by construction.
 */
export const AtlasFieldBridge: {
  open: ((sourceBlock: any) => void) | null;
  /** On-attach same-entity guard: entity setters call this from setOnChange; the component
   *  (validateEntityChildMatch) unplugs a configured child whose entity ≠ the setter's target. */
  validateEntityChild: ((setBlock: any) => void) | null;
  /** Installs the on-attach guard on a block (its setOnChange). The LOGIC lives in the component
   *  (installEntityGuard) — block inits in the helper files call this, so no helper owns the guard and
   *  there is no cross-helper / circular import. Registered by the component in ngAfterViewInit. */
  attachEntityGuard: ((block: any) => void) | null;
} = {
  open: null,
  validateEntityChild: null,
  attachEntityGuard: null,
};
